import { render, staticRenderFns } from "./PosOtherRec.vue?vue&type=template&id=41d78663&"
import script from "./PosOtherRec.vue?vue&type=script&lang=js&"
export * from "./PosOtherRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports